import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import { ChartPieDataSchema, ChartPieUISchema } from './types'
import { PieChartBody } from './PieChartBody'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'

export function ChartPieContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: ChartPieUISchema
  dataSchema: ChartPieDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader } = uiSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)
  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>{tileFilters}</ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <PieChartBody chartConfig={uiSchema.chartConfig} data={dataSchema.data} />
      </div>
    </div>
  )
}
